var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGambia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 0C9.38505 0 3.7083 4.01413 1.27148 9.73913H30.728C28.2912 4.01413 22.6144 0 15.9997 0Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 31.9999C22.6144 31.9999 28.2912 27.9857 30.728 22.2607H1.27148C3.7083 27.9857 9.38505 31.9999 15.9997 31.9999Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4488 11.8262H0.551188C0.1925 13.157 0 14.5559 0 16.0001C0 17.4443 0.1925 18.8432 0.551188 20.174H31.4489C31.8075 18.8432 32 17.4443 32 16.0001C32 14.5559 31.8075 13.157 31.4488 11.8262Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGambia);
export default __webpack_public_path__ + "static/media/flag_gambia.a5f38ec246ff01feec616387a1bbf66c.svg";
export { ForwardRef as ReactComponent };